function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from 'react';
const SvgPhoneEnd = props => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  width: 16,
  height: 16,
  fill: "none",
  viewBox: "0 0 16 16",
  "data-animate": props.isAnimate || false,
  "data-interactive": props.animateOnInteraction || false
}, props), /*#__PURE__*/React.createElement("path", {
  stroke: props.color || 'currentColor',
  strokeLinecap: "round",
  strokeLinejoin: "round",
  strokeWidth: 2,
  d: "m2.433 10.63-1.12-1.26a1.21 1.21 0 0 1-.24-.41A1.322 1.322 0 0 1 1.109 8c.066-.149.158-.28.27-.386C2.655 6.46 4.152 5.66 5.752 5.278a9.19 9.19 0 0 1 4.483 0c1.606.386 3.109 1.192 4.386 2.353.113.105.205.236.27.384a1.308 1.308 0 0 1 .039.957 1.213 1.213 0 0 1-.238.41l-1.12 1.261a1.01 1.01 0 0 1-.676.353.976.976 0 0 1-.714-.235 6.682 6.682 0 0 0-1.312-.887 1.103 1.103 0 0 1-.45-.435 1.296 1.296 0 0 1-.17-.64v-.8a7.552 7.552 0 0 0-4.483 0v.8c-.001.227-.06.45-.17.64a1.1 1.1 0 0 1-.45.435 6.68 6.68 0 0 0-1.312.887.975.975 0 0 1-.722.235 1.015 1.015 0 0 1-.679-.365Z"
}));
export default SvgPhoneEnd;